import { TablePagination, TablePaginationProps } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';

interface ICommonPaginationProps {
  total?: number;
  paginationCalFun?: (limit: number, skip: number) => void;
  dataShowPerPage?: number;
}

export const CommonPagination = ({
  total,
  paginationCalFun,
  dataShowPerPage,
}: ICommonPaginationProps) => {
  const [page, setPage] = useState(0);
  //how many data show per page
  const [rowsPerPage, setRowsPerPage] = useState(dataShowPerPage || 50);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    const skip = page === 0 ? 0 : page * rowsPerPage;
    paginationCalFun && paginationCalFun(rowsPerPage, skip);
  }, [page, rowsPerPage]);

  return (
    <TablePagination
      component='div'
      count={total || 0}
      page={page}
      onPageChange={handleChangePage}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      rowsPerPageOptions={[50, 100, 500]}
    />
  );
};
